module.exports = __webpack_public_path__ + "img/xiaofang2.fe911828.svg";